<div class="small-padding">
  <form [formGroup]="loginForm" class="align-center" (ngSubmit)="signin()">
    <div class="small-margin">
      <input
        kendoTextBox
        class="full-size email-class"
        formControlName="login"
        [placeholder]="'Email'"
        [ngClass]="{ 'alert-border': invalidLogin }"
      />
    </div>
    <div class="small-margin">
      <input
        kendoTextBox
        type="password"
        class="full-size pass-class"
        formControlName="mdp"
        [placeholder]="'Mot de passe'"
        [ngClass]="{ 'alert-border': invalidMdp }"
      />
    </div>
    <div class="login-button">
      <button
        class="colored-text full-size connect-button primary-background"
        kendoButton
        [primary]="true"
        [disabled]="submitted"
      >
        <ng-container *ngIf="!submitted; else loading">
          SE CONNECTER
        </ng-container>
        <ng-template #loading>CHARGEMENT...</ng-template>
      </button>
    </div>
    <div *ngIf="loginError" class="alert-color not-found-user">
      Utilisateur ou mot de passe incorrect.<br />
      Veuillez réessayer.
    </div>
  </form>

  <div class="login-links">
    <a
      class="basic-text clickable"
      [routerLink]="renewPopup ? [] : getLinksRoute('renew')"
      (click)="renewPopup ? renewEmit.emit() : null"
    >
      Mot de passe oublié ?
    </a>
  </div>
  <div class="login-links" *ngIf="accountCreation">
    <a class="primary-color" [routerLink]="getLinksRoute('signup')">
      <div class="k-icon k-i-arrow-chevron-right small-padding primary-color"></div>
      <b>Créer un compte</b>
    </a>
  </div>
</div>
